export const googleMapsBaseUrl = 'https://www.google.com/maps/search/';

export const aboutStackSource = 'https://www.stacksource.com/how-it-works';

export const termsConditionsUrl = 'https://www.stacksource.com/terms-conditions';

export const privacyPolicyUrl = 'https://www.stacksource.com/privacy';
